import { render, staticRenderFns } from "./ZoneEditor.vue?vue&type=template&id=37fa93fc&scoped=true"
import script from "./ZoneEditor.vue?vue&type=script&lang=js"
export * from "./ZoneEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fa93fc",
  null
  
)

export default component.exports